import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { identityState, messageDispatcher } from '../../store';
import { translate } from '../../services';
import { connect } from 'react-redux';
import { Box, Dialog, Drawer, Input, InputAdornment, IconButton as MuiIconButton, TextField} from '@mui/material';
import { Directions, Padding, PieChartSharp } from '@mui/icons-material';
import { CloseLightIconNew, EditIConNew, MinusIconActive, MinusIconNewSvg, VectorCounterMinusIcon, VectorCounterPlusIcon, closePopup } from '../../../style/images';
import classNames from 'classnames';

export class QuantityFieldComponent extends Component {  
  constructor() {
    super();
    this.state = {
      currentAmount: undefined,
      validated: true,
      show:false,
      minusIcon:null,
      quantity: null,
    };
  }

  componentDidMount( ) {
    const { amount, minOrderAmount } = this.props;
    const { currentAmount,validated } = this.state;
    const value = validated ? amount || 0 : currentAmount;
if(!this.state.currentAmount && value){
      this.setState({currentAmount:value})
    }
    if(!this.state.minusIcon){
      this.setState({minusIcon:value<=minOrderAmount?VectorCounterMinusIcon:MinusIconActive})
    }
    if(!this.state.quantity){
      this.setState({quantity:value});
    }
  }
  componentDidUpdate( prevProps ) {
    const { amount, minOrderAmount } = this.props;
    const { currentAmount,validated } = this.state;
    if(validated && (amount!=prevProps.amount)){
      this.setState({currentAmount:amount})
    }

    if(!this.state.minusIcon){
      this.setState({minusIcon:currentAmount<=minOrderAmount?VectorCounterMinusIcon:MinusIconActive})
    }
    if(!this.state.quantity){
      this.setState({quantity:currentAmount});
    }
  }

  validate( value ) {
    return /^\d+(.{1}\d+)?$/.test( value ) && 
    (this.props.fromModelConfigurator ? Number( value ) >= 0 : Number( value ) > 0) && 
    Number( value ) < 100000;
  }
  addMessage = ( valueUpdated, stock ) => {
    if(valueUpdated > stock){
      let stockText = translate('Insufficient availability, {stock} pieces are available.', {stock : stock});
      this.props.addMessage( { messageText: stockText + '\n' + translate('CONTACT_CUSTOMER_CARE'), 
        messageType: 'warning', 
        timeout: 0 
      } );
    }
  }

  setValue = (e, action, currentValue)=>{
    let value = e.target.value;
    let {incrementBy, minOrderAmount} = this.props; 
    if(action){
      value = this.state.quantity
      if(action==="minus"){
        value = value-incrementBy
      }
      else{
        value = value+incrementBy
      }
    }
    let valueUpdated = parseInt(value);
    if(this.props.user.authenticationType === 'WS' && value !=""){
      let stock = parseInt(this.props.stock);
      if(valueUpdated > stock){
       setTimeout(this.addMessage(valueUpdated, stock), 2000);
       //this.props.addMessage( { messageText: translate('Quantity Exceeded Stock'), messageType: 'warning', timeout: 0 } );
      }
    }
    if( !this.validate( value ) ) {
      this.setState( { currentAmount: value, validated: false } );
      return;
    }
    this.setState({quantity:valueUpdated, currentAmount: value, validated: true, minusIcon:value<=minOrderAmount?VectorCounterMinusIcon:MinusIconActive});
  }

  onAddMobile = ()=>{
    this.props.onChange( Number( this.state.quantity ) );
    this.close()
  }

  onChange = (e, action, currentValue) => {
    let value = e.target.value;
    let {incrementBy, minOrderAmount} = this.props; 
    if(action){
      value = currentValue
      if(action==="minus"){
        value = value-incrementBy
      }
      else{
        value = value+incrementBy
      }
    }
    let valueUpdated = parseInt(value);
    if(this.props.user.authenticationType === 'WS' && value !=""){
      let stock = parseInt(this.props.stock);
      if(valueUpdated > stock){
       setTimeout(this.addMessage(valueUpdated, stock), 2000);
       //this.props.addMessage( { messageText: translate('Quantity Exceeded Stock'), messageType: 'warning', timeout: 0 } );
      }
    }
    if( !this.validate( value ) ) {
      this.setState( { currentAmount: value, validated: false } );
      return;
    }
    
    this.setState( { currentAmount: value, validated: true, minusIcon:value<=minOrderAmount?VectorCounterMinusIcon:MinusIconActive}, () => {
      this.props.onChange( Number( value ) );
    } );
  }

  onBlur = () => {
    const { amount, incrementBy, minOrderAmount } = this.props;

    if( this.props.onBlur !== undefined ) {
      this.props.onBlur( amount, incrementBy, minOrderAmount );
    }
    // revert to a previous state
    this.setState( { validated: true } );
  }
  
  open = ()=>{
    this.setState({show:true})
    //for mobile cart
    this.props.setHideItemActions && this.props.setHideItemActions()
    // this.props.closeItemActions && this.props.closeItemActions()
  }

  close = ()=>{
    this.setState({show:false})
    //for mobile cart
    this.props.closeDialog && this.props.closeDialog()
  }

  addToCart = ()=>{
    this.props.onAdd && this.props.onAdd()
    this.props.showQuantity()
  }

  getWarningComponent( showWarning, product, warnPopup ) {
    if (showWarning && hasBomItemAssignment( product ) && !warnPopup ) {
      // return <span key="warning" className="floating outward" title={translate('missing_bom_item')}>!</span>
      return true;
    }
    return false;
  }
  // validate func to check decimal input 
  inputValidation = (e) => {
    if(e.key==='.') {
      e.preventDefault();
    }
  }
   
  render() {
    const { amount, hidden, readonly, minOrderAmount, incrementBy } = this.props;
    const { currentAmount, validated } = this.state;
    const value = validated ? amount || 0 : currentAmount;
    const AddToCartButton = this.props.addToCartButton

    
    return hidden 
      ? <div className="hidden" /> 
      //for desktop quantity field
      :<>{!this.props.mobileCartView && !this.props.showQuantityPopUp?
        <div className='quantity-actions'>
          <Box sx={{
            display:"flex",
            flexDirection: "row",
            justifyContent:"center",
            alignItems:"center",
            border: "1px solid #DBDBDB",
            height:'32px',
            width:'32px',
            // padding: '8px 0px'
          }}>
            <MuiIconButton disableFocusRipple disableRipple disableTouchRipple disabled={currentAmount<=minOrderAmount} style={{width:'100%', height:'100%'}} onClick={(e)=>{e.stopPropagation();this.onChange(e, "minus", value)}}>
              <Box component="img" src={this.state.minusIcon}></Box>
            </MuiIconButton>
          </Box>
          <input disabled={ readonly } className="quantity-field" type="number" min={ minOrderAmount } step={ incrementBy } value={ value } onKeyDown={this.inputValidation} onChange={ this.onChange } onBlur={ this.onBlur } />
          <Box sx={{
            display:"flex",
            flexDirection: "row",
            alignItems:"center",
            border: "1px solid #DBDBDB",
            height:'32px',
            width:'32px'
          }}>
            <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={(e)=>{e.stopPropagation();this.onChange(e, "plus", value)}}>
              <Box component="img" src={VectorCounterPlusIcon}></Box>
            </MuiIconButton>
          </Box>
        </div>:<>{
          //for mobile quantity field other than cart
          this.props.showQuantityPopUp?<>
          <Dialog open={this.props.showQuantityPopUp} onClose={this.props.showQuantity} sx={{}} PaperProps={{sx:{margin:"24px"}}}>
            {/* <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.props.showQuantity} width="24px" height="24px" sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5", height:"20px", width:"20px", borderRadius:"56px"}}>
                <Box component="img" src={CloseLightIconNew}></Box>
            </MuiIconButton> */}
            <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.props.showQuantity} sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5",width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}, borderRadius:"56px" , backgroundColor: 'white'}}>
              <Box component="img" src={closePopup} style={{width: 'inherit', height: 'inherit'}} sx={{height:"24px", width:"24px"}}></Box>
            </MuiIconButton>
                <div className='quantity-dialog'>
                  <div className='quantity-field'>
                    <div className='content'>
                      <span>
                        {translate("Select quantity")+":"}
                      </span>
                      <div className='actions'>
                        <MuiIconButton disableFocusRipple disableRipple disableTouchRipple disabled={currentAmount<=minOrderAmount}>
                          <div className='buttons' onClick={(e)=>{this.onChange(e, "minus", value)}}>
                            <Box component="img" src={this.state.minusIcon} sx={{fill:value>1?"black":"none"}}></Box>
                          </div>
                        </MuiIconButton>
                            <Box sx={{display:"flex", flexDirection:"row", justifyContent:"center", alignItems:"center", gap:"1px"}}>
                              {/* <input disabled={ readonly } className="text" type="text" min={ minOrderAmount } step={ incrementBy } value={ value } onChange={ this.onChange } onBlur={ this.onBlur }/> */}
                              <Input
                                id="standard-adornment-weight"
                                endAdornment={<InputAdornment position="end" sx={{ml:"2px"}}><span className='pcs'>pcs.</span></InputAdornment>}
                                aria-describedby="standard-weight-helper-text"
                                inputProps={{
                                  type:'number',
                                  min:0,
                                  'aria-label': 'weight',
                                  'color': 'var(--primary-color-grey-100, #0F0F0F)',
                                  'font-size':'14px',
                                  'font-family': 'ABBvoice Regular',
                                  style:{textAlign:'center'}
                                }}
                                sx={{width:"55px", padding:"0px",fontFamily:'ABBvoice Regular', color:'var(--primary-color-grey-100, #0F0F0F)',fontSize:"14px"}}
                                disabled={readonly}
                                value={value}
                                onChange={this.onChange}
                                onBlur={this.onBlur}
                                disableUnderline={true}
                                
                                />
                              {/* <TextField type='number' value={value} InputProps={{inputProps: { min: minOrderAmount }}} onChange={this.onChange} label="what ever"></TextField> */}
                            </Box>
                          <div className='buttons' onClick={(e)=>{this.onChange(e, "plus", value)}}>
                            <Box component="img" src={VectorCounterPlusIcon}></Box>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div className='footer'>
                      <div className='tertiary-button' onClick={ this.props.showQuantity }><span>{ translate( 'Cancel' ) }</span></div>
                      {/* <div className='primary-button' onClick={ this.addToCart }><span>{ translate( 'Add To Cart' ) }</span></div> */}
                      {this.props.addToCartButton}
                    </div>
                </div>
            </Dialog> 
          </>:
          //only for mobile cart field
          <>
            <div className="items" onClick={this.open}>
              <MuiIconButton disableFocusRipple disableRipple disableTouchRipple><Box component="img" src={EditIConNew} sx={{width:"20px", height:"20px"}}></Box></MuiIconButton>
              <span>{translate("Change quantity")}</span>
            </div>
            <Dialog open={this.state.show} onClose={this.close} sx={{}} PaperProps={{sx:{margin:"24px"}}}>
            {/* <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.close} width="24px" height="24px" sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5", height:"20px", width:"20px", borderRadius:"56px"}}>
                <Box component="img" src={CloseLightIconNew}></Box>
            </MuiIconButton> */}
            <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.close} sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5",width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}, borderRadius:"56px" , backgroundColor: 'white'}}>
              <Box component="img" src={closePopup} style={{width: 'inherit', height: 'inherit'}} sx={{height:"24px", width:"24px"}}></Box>
            </MuiIconButton>
                <div className='quantity-dialog'>
                  <div className='quantity-field'>
                    <div className='content'>
                      <span>
                        {translate("Select quantity")+":"}
                      </span>
                      <div className='actions'>
                        <MuiIconButton disableFocusRipple disableRipple disableTouchRipple disabled={currentAmount<=minOrderAmount}>
                          <div className={classNames('buttons', {'active':currentAmount>minOrderAmount})} onClick={(e)=>{this.setValue(e, "minus", value)}}>
                            <Box component="img" src={this.state.minusIcon} sx={{fill:value>1?"black":"none"}}></Box>
                          </div>
                        </MuiIconButton>
                            <Box sx={{display:"flex", flexDirection:"row", justifyContent:"center", alignItems:"center", gap:"1px"}}>
                              {/* <input disabled={ readonly } className="text" type="text" min={ minOrderAmount } step={ incrementBy } value={ value } onChange={ this.onChange } onBlur={ this.onBlur }/> */}
                              <Input
                                id="standard-adornment-weight"
                                endAdornment={<InputAdornment position="end" sx={{ml:"2px"}}><span className='pcs'>pcs.</span></InputAdornment>}
                                aria-describedby="standard-weight-helper-text"
                                inputProps={{
                                  type:'number',
                                  min:0,
                                  'aria-label': 'weight',
                                  'color': 'var(--primary-color-grey-100, #0F0F0F)',
                                  'font-size':'14px',
                                  'font-family': 'ABBvoice Regular',
                                  style:{textAlign:'center'}
                                }}
                                sx={{width:"55px", padding:"0px",fontFamily:'ABBvoice Regular', color:'var(--primary-color-grey-100, #0F0F0F)',fontSize:"14px"}}
                                disabled={readonly}
                                value={this.state.quantity}
                                onChange={this.onChange}
                                onBlur={this.onBlur}
                                disableUnderline={true}
                                
                                />
                              {/* <TextField type='number' value={value} InputProps={{inputProps: { min: minOrderAmount }}} onChange={this.onChange} label="what ever"></TextField> */}
                            </Box>
                          <div className={classNames('buttons', 'active')} onClick={(e)=>{this.setValue(e, "plus", value)}}>
                            <Box component="img" src={VectorCounterPlusIcon}></Box>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div className='footer'>
                      <div className='tertiary-button' onClick={ this.close }><span>{ translate( 'Cancel' ) }</span></div>
                      <div className='primary-button' onClick={ this.onAddMobile }><span>{ translate( 'Add To Cart' ) }</span></div>
                      
                    </div>
                </div>
            </Dialog> 
          </>
        }
        </>}
      </> ;
  }
}

QuantityFieldComponent.propTypes = {
  amount: PropTypes.number.isRequired,
  hidden: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  readonly: PropTypes.bool,
  addMessage: PropTypes.func.isRequired,
};
export const QuantityField = connect( identityState, messageDispatcher )( QuantityFieldComponent );
